import { z } from "zod/v4";

export const SearchUserResultSchema = z.object({
	name: z.string(),
	nickname: z.string(),
	// this is intentionally a string because url will crash the UserSearchBox otherwise
	picture: z.string().optional().or(z.literal("")),
	user_id: z.string(),
});
export type SearchUserResult = z.infer<typeof SearchUserResultSchema>;
